
        import 'Markers.211a95b.css-module'
        export default {"Marker":"Marker_Markers_211a95b","hovered":"hovered_Markers_211a95b"}
    